// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:24:18

export default {
  "id": "last-standing",
  "slug": "last-standing",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5879ec933bf046dabef3ef2cccbd239d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5879ec933bf046dabef3ef2cccbd239d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Last Standing",
      "description": "Players are dropped onto a map and start without weapons. The map is scattered with a wealth of weapons and equipment. Players need to constantly explore and collect these resources to enhance their survival ability and combat power. The core goal of the game is to be the last survivor. Usually, there are multiple players in each game, and they are randomly distributed on the map. ",
      "instructions": "As the game progresses, the safe zone will gradually shrink, forcing players to gather towards the central area, increasing the chances of encounters. Players need to search for weapons and other items that can improve their survival ability. The game also tests players' strategic planning and psychological quality. virtual joystick or WASD keyboard",
      "genres": [
        "Battle",
        "Shooter"
      ],
      "tags": [
        "battlefield",
        "boy",
        "fighting",
        "shoot-em-up",
        "survival"
      ]
    },
    "zh-CN": {
      "title": "最后的幸存者",
      "description": "玩家被投放到地图上，开始时没有武器。地图上散布着丰富的武器和装备。玩家需要不断探索和收集这些资源，以增强他们的生存能力和战斗力。游戏的核心目标是成为最后的幸存者。通常，每局游戏中都有多名玩家，他们会在地图上随机分布。",
      "instructions": "随着游戏进程，安全区域将逐渐缩小，迫使玩家聚集在中央区域，增加遭遇战的可能性。玩家需要寻找武器和其他可以提高生存能力的物品。游戏还考验玩家的战略规划和心理素质。虚拟摇杆或WASD键盘",
      "genres": [
        "战斗",
        "射击"
      ],
      "tags": [
        "战场",
        "男孩",
        "战斗",
        "射击",
        "生存"
      ]
    },
    "zh-TW": {
      "title": "最後站立者",
      "description": "玩家被投放到地圖上，開始遊戲時沒有武器。地圖上散布著大量的武器和裝備。玩家需要不斷探索並收集這些資源來提升自己的生存能力和戰鬥力。遊戲的核心目標是成為最後一名倖存者。通常，每場遊戲中都有多個玩家，他們在地圖上是隨機分配的。",
      "instructions": "隨著遊戲進行，安全區域將逐漸縮小，迫使玩家聚集在中央地區，增加遭遇戰的機會。玩家需要尋找武器和其他能夠提升其生存能力的物品。遊戲還考驗玩家的策略規劃和心理素質。虛擬摇桿或WASD鍵盤",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "戰場",
        "男孩",
        "戰鬥",
        "射擊遊戲",
        "生存"
      ]
    },
    "zh-HK": {
      "title": "最後站立者",
      "description": "玩家被丟落在地圖上，並在沒有武器的情況下開始遊戲。地圖上散佈著豐富的武器和裝備。玩家需要不斷探索和收集這些資源以提升生存能力和作戰力。遊戲的核心目標是成為最後的倖存者。通常，每場遊戲中都有多個玩家，他們在地圖上隨機分佈。",
      "instructions": "隨著遊戲進行，安全區域將逐漸縮小，迫使玩家聚集於中央地區，增加遭遇戰的機會。玩家需要尋找武器和其他能夠提升生存能力的物品。遊戲同時也考驗玩家的策略規劃和心理素質。虛擬搖桿或WASD鍵盤",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "戰場",
        "少年",
        "戰鬥",
        "射擊遊戲",
        "生存"
      ]
    },
    "ja": {
      "title": "最後の生き残り",
      "description": "プレイヤーは地図に落下し、武器なしでゲームを開始します。地図には豊富な武器と装備が散らばっています。プレイヤーはこれらのリソースを常に探索し、収集し、生存能力と戦闘力を高める必要があります。ゲームの核心の目標は最後の生き残りになることです。通常、各ゲームには複数のプレイヤーがおり、地図上にランダムに配置されます。",
      "instructions": "ゲームが進むにつれて、安全区域は徐々に縮小し、プレイヤーを中央エリアに集約させ、遭遇の確率を高めます。プレイヤーは生存能力を向上させるための武器や他のアイテムを探す必要があります。ゲームはまた、プレイヤーの戦略的計画と心理的な質を試します。バーチャルジョイスティックまたはWASDキーボード",
      "genres": [
        "バトル",
        "シューティング"
      ],
      "tags": [
        "バトルフィールド",
        "少年",
        "戦闘",
        "シューティングアップ",
        "サバイバル"
      ]
    },
    "ko": {
      "title": "최후의 생존자",
      "description": "플레이어들은 맵에 떨어져 무기를 가지지 않고 시작합니다. 맵에는 무기와 장비가 풍부하게 배치되어 있습니다. 플레이어들은 지속적으로 탐험하고 이러한 자원을 수집하여 생존 능력과 전투력을 강화해야 합니다. 게임의 핵심 목표는 마지막 생존자가 되는 것입니다. 일반적으로 각 게임에는 여러 플레이어가 있으며, 맵에 무작위로 배치됩니다.",
      "instructions": "게임이 진행될수록 안전구역은 점차 축소되어, 플레이어들이 중앙 지역으로 모이게 만들어 만남의 기회를 높입니다. 플레이어들은 생존 능력을 향상시킬 수 있는 무기와 다른 아이템을 찾아야 합니다. 게임은 또한 플레이어들의 전략적 계획과 심리적 질을 테스트합니다. 가상 조이스틱 또는 WASD 키보드",
      "genres": [
        "전투",
        "총구射手"
      ],
      "tags": [
        "전장",
        "소년",
        "전투",
        "쏘아치는 게임",
        "생존"
      ]
    },
    "fr": {
      "title": "Dernier Survivant",
      "description": "Les joueurs sont débarqués sur une carte et commencent sans armes. La carte est parsemée d'une multitude d'armes et d'équipements. Les joueurs doivent constamment explorer et collecter ces ressources pour améliorer leur capacité de survie et leur puissance de combat. Le but principal du jeu est d'être le dernier survivant. Habituellement, il y a plusieurs joueurs dans chaque partie, et ils sont distribués de manière aléatoire sur la carte.",
      "instructions": "Au fur et à mesure que le jeu progresse, la zone sécurisée se réduira progressivement, forçant les joueurs à se regrouper vers la zone centrale, augmentant les chances de confrontations. Les joueurs doivent chercher des armes et d'autres objets qui peuvent améliorer leur capacité de survie. Le jeu teste également la planification stratégique et la qualité psychologique des joueurs. manette virtuelle ou touches WASD du clavier",
      "genres": [
        "Bataille",
        "tireur"
      ],
      "tags": [
        "champ de bataille",
        "garçon",
        "combat",
        "tire-l'œil",
        "survie"
      ]
    }
  }
};
